/* src/app/components/footer/footer.component.scss */
footer {
  max-width: 1400px;
  margin: 4rem auto 1rem;
  color: #555;
  font-size: 0.9rem;
  flex-shrink: 0;
}
footer > * {
  margin: 5px 15px;
}
.coat_of_arms {
  padding-top: 25px;
  padding-right: 15px;
}
.coat_of_arms img {
  max-width: 9rem;
}
@media screen and (min-width: 960px) {
  .coat_of_arms {
    padding-top: 0;
    text-align: right;
  }
  .coat_of_arms img {
    max-width: 10rem;
  }
}
.label {
  display: block;
  text-transform: uppercase;
  color: rgb(163, 163, 163);
  font-size: 0.75rem;
  margin-bottom: 0.25rem;
}
.whitecolor {
  color: rgba(255, 255, 255, 0.6666666667) !important;
}
.whitecolor .label {
  color: rgba(255, 255, 255, 0.8) !important;
}
/*# sourceMappingURL=footer.component.css.map */
